/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseListMandateData } from './genericApiResponseListMandateData';
import type { GenericApiResponseListMandateMessage } from './genericApiResponseListMandateMessage';
import type { GenericApiResponseListMandatePagination } from './genericApiResponseListMandatePagination';
import type { GenericApiResponseListMandateError } from './genericApiResponseListMandateError';

export interface GenericApiResponseListMandate {
  data?: GenericApiResponseListMandateData;
  message?: GenericApiResponseListMandateMessage;
  pagination?: GenericApiResponseListMandatePagination;
  error?: GenericApiResponseListMandateError;
  statusCode?: number;
}
